import invoiceModule from '../module'
import blueFinderPage from '../view/blueFinder.html'

export default class BlueFinderCtrl {
    constructor($scope, $uibModalInstance, invType, httpRequest, logger, globalFn, $uibModal, $http, sweetalert) {
        httpRequest.get_dictByTypeArr(['invoice_status', 'ovat_tax_rate', 'inv_type_red']).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
        })
        $scope.injectInvType = invType
        // 初始化参数
        $scope.modaldata = {
            pageSize: 5,
            pageNum: 1,
            param: {
                cancelDateMax: '',
                cancelDateMin: '',
                custCodeName: '',
                diskCode: '',
                invType,
                invoiceCode: '',
                invoiceCodeNumber: '',
                invoiceDateMax: '',
                invoiceDateMin: '',
                invoiceNumber: '',
                isCancel: '0',
                isList: '',
                isPrint: '',
                isRed: '0',
                isReopen: '',
                openPeople: '',
                ukeyCode: '',
                invoiceDateBegin: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-1`,
                invoiceDateEnd: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`,
                taxRate: '',
            },
        }

        $scope.selectedHandle = function selectedHandle() {
            $scope.modaldata.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.modaldata.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            $scope.searchInvoicelist()
        }

        // 增加排序功能
        $scope.orderMap = {
            sortKey: 'invoiceDate',
            sortVal: 'desc',
        }
        $scope.modaldata.orderMap = { invoiceDate: 'desc' }

        function queryInvoiceList() {
            httpRequest.post_getNormalBlueInvoice($scope.modaldata).then((res) => {
                $scope.modaldata.list = res.data.value.list
                $scope.totalItems = res.data.value.total
            })
        }
        // 搜索
        $scope.searchInvoicelist = queryInvoiceList
        $scope.searchInvoicelist()
        // 选择
        $scope.chooseInvoiceItem = function chooseInvoiceItem(item) {
            if (item.redAmount === 0) {
                logger.logError('您选择的蓝票可红冲金额为0，请重新选择')
                return
            }
            httpRequest.post_getOvatInvoice(item.invoiceId).then((res) => {
                const params = {
                    pageNum: 0,
                    pageSize: 0,
                    param: {
                        invoiceID: item.invoiceId,
                    },
                }
                const result = res.data.value
                httpRequest.post_getPageInvoiceDetail(params).then((res) => {
                    const list = res.data.value && res.data.value.list
                    if (list) result.invoiceDetailList = res.data.value.list
                    $uibModalInstance.close(result)
                })
            })
        }

        // 关闭
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel')
        }
    }
}

BlueFinderCtrl.$inject = ['$scope', '$uibModalInstance', 'invType', 'httpRequest', 'logger', 'globalFn', '$uibModal', '$http', 'sweetalert', '$timeout']
invoiceModule.controller('blueFinderCtrl', BlueFinderCtrl)
invoiceModule.component('blueFinder', {
    bindings: {
        invoice: '<',
        onSelect: '&',
    },
    template: `
        <button class="btn btn-primary btn-lg clearfix roll-search-blue" ng-click="ctrl.openDialog()">
            <i class="icon iconfont icon-sousuo f-fl"></i><span class="f-fl">查找蓝票</span>
        </button>
    `,
    controllerAs: 'ctrl',
    controller: ['httpRequest', '$uibModal', function ctrl(httpRequest, $uibModal) {
        const finder = this
        finder.openDialog = function openDialog() {
            const modalInstance = $uibModal.open({
                template: blueFinderPage,
                controller: 'blueFinderCtrl',
                openedClass: 'mod-modal-haslist blue-invoice-list mod-modal mod-modal-too-hg',
                backdrop: 'static',
                resolve: {
                    invType() {
                        return finder.invoice.invType
                    },
                },
            })
            modalInstance.result.then((item) => {
                finder.onSelect({ item })
            }, () => {
            })
        }
    }],
})



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/components/blueFinder.js